import "../Feed/style.css";

import { Link } from "react-router-dom";

import { useAuth } from "../../auth/AuthContext";

export default function TopNavBar({ inviteIsActive, setInviteIsActive }) {
  const { session, logout } = useAuth();
  const member = session.member;

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="home-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </Link>
        {setInviteIsActive && (
          <button
            className="interaction-button"
            type="submit"
            onClick={() =>
              setInviteIsActive((inviteIsActive) => !inviteIsActive)
            }
          >
            {!inviteIsActive ? "Grow the Family!" : "Shrink the family"}
          </button>
        )}
        <h1>{member.first_name}'s Family</h1>
        <button
          className="interaction-button logout-button"
          type="button"
          onClick={logout}
        >
          Log out
        </button>
      </div>
    </header>
  );
}
